// extracted by mini-css-extract-plugin
export default {"zoomModal":"w2-z"};